// extracted by mini-css-extract-plugin
module.exports = {"socialMenu":"_socialMenu_socialMenu__IWIh1","iconLink":"_socialMenu_iconLink__0ijiW"};